module.exports = __webpack_public_path__ + "img/HeatherMcConnell.d08ee610.jpg";